export const purchaseHistorySx = {
    purchaseHistoryBox: { display: { xs: 'none', md: 'block' } },
    tabTextCourses: {
        cursor: "pointer",
        pl: 1,
        pr: 1,
        pb: 2
    },
    tabTextRefunds: {
        cursor: "pointer",
        pl: 1,
        pr: 1,
        pb: 2
    },
    scrollBox: {
        overflowY: 'scroll',
        '::-webkit-scrollbar': { display: 'none' },
        height: "100%"
    }
};
